import type { ReactNode } from 'react'

export function StatCard({
  label,
  value,
  delta,
  icon,
  tone = 'neutral',
}: {
  label: string
  value: string | number
  delta?: string
  icon?: ReactNode
  tone?: 'neutral' | 'up' | 'warn' | 'crit'
}) {
  const deltaColor =
    tone === 'up'
      ? 'text-emerald-700 border-emerald-200 bg-emerald-50/80'
      : tone === 'warn'
      ? 'text-amber-700 border-amber-200 bg-amber-50/80'
      : tone === 'crit'
      ? 'text-rose-700 border-rose-200 bg-rose-50/80'
      : 'text-slate-600 border-slate-200 bg-slate-100/80'

  const isTextValue = typeof value === 'string' && isNaN(Number(value))

  return (
    <div className="glass-card relative flex flex-col justify-between rounded-xl border border-slate-200/90 bg-white p-4 shadow-xs hover:border-sky-300 hover:shadow-md transition-all duration-200">
      <div>
        <div className="flex items-center justify-between gap-2">
          <span className="font-sans text-[11px] font-bold uppercase tracking-wider text-slate-500 truncate">
            {label}
          </span>
          {icon && (
            <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-sky-50 text-sky-700 border border-sky-100 shadow-2xs">
              {icon}
            </span>
          )}
        </div>
        <div
          className={`mt-2 tracking-tight ${
            isTextValue
              ? 'font-sans text-base sm:text-lg font-bold text-slate-800'
              : 'font-display text-xl sm:text-2xl font-extrabold text-slate-900'
          }`}
        >
          {value}
        </div>
      </div>

      {delta && (
        <div className="mt-3 flex items-center">
          <span className={`inline-flex items-center rounded-md border px-2 py-0.5 font-mono text-[10.5px] font-semibold shadow-2xs ${deltaColor}`}>
            {delta}
          </span>
        </div>
      )}
    </div>
  )
}
